module.exports = __webpack_public_path__ + "img/details-offer__post1.png?c44e2d4c4bd70f6b6872fb78a8c613a9";